export default __webpack_public_path__ + "static/jody-clark-2c0e94e5a52cadf30f14d5ef6b420f2f.jpeg";